<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {}
}
</script>
<style>
.global-messageZindex {
  z-index:3000 !important;
}
</style>
